import CircularLoader from "app/components/CircularLoader";
import React from "react";

const LoaderOverlay = () => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-white/50 backdrop-blur-sm">
      <CircularLoader size="xl" />
    </div>
  );
};

export default LoaderOverlay;
